export const APP_CLIPBOARD_APPEND = 'angel:clipboard:append';

export type AppClipboardRequest = { text: string; handled: boolean; completion?: Promise<boolean> };

/** Send selected Markdown to the built-in Clipboard, not the OS clipboard. */
export async function appendToAppClipboard(text: string): Promise<boolean> {
  if (!text.trim()) return false;
  const request: AppClipboardRequest = { text, handled: false };
  window.dispatchEvent(new CustomEvent(APP_CLIPBOARD_APPEND, { detail: request }));
  return request.handled && request.completion ? await request.completion : false;
}
